import { useEffect, useState } from 'react'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom'

export function Layout() {
  const [scrolled, setScrolled] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8)
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className="shell">
      <header className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <Link to="/" className="nav-brand" aria-label="AIAS MUSIC home">
          <img src="/brand/aias-mark.png?v=20261018" alt="" width={36} height={36} />
          <span className="nav-brand-text">AIAS MUSIC</span>
        </Link>
        <nav className="nav-links" aria-label="Primary">
          <NavLink to="/music" className={({ isActive }) => (isActive ? 'active' : undefined)}>
            Music
          </NavLink>
        </nav>
      </header>
      <main className="main">
        <Outlet />
      </main>
      <footer className="footer">
        <div>© {new Date().getFullYear()} AIAS MUSIC</div>
        <div className="footer-social" aria-label="Social links">
          <a
            className="footer-icon-link"
            href="https://open.spotify.com/artist/0shXBX7WAdXe8ry9xUNav8"
            target="_blank"
            rel="noreferrer"
            aria-label="AIAS on Spotify"
            title="Spotify"
          >
            <svg className="footer-icon footer-icon-spotify" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"
              />
            </svg>
          </a>
          <a
            className="footer-icon-link"
            href="https://music.apple.com/us/artist/roy-doumet/1895241498"
            target="_blank"
            rel="noreferrer"
            aria-label="AIAS on Apple Music"
            title="Apple Music"
          >
            <svg className="footer-icon footer-icon-apple" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M20.5 3.2c-1.2-.5-2.8-.3-4.2.5l-6.1 3.5c-.7.4-1.2 1.1-1.2 1.9v6.6c-.6-.3-1.3-.5-2-.5-2 0-3.6 1.3-3.6 3s1.6 3 3.6 3 3.6-1.3 3.6-3V9.9l6.5-3.7v5.3c-.6-.3-1.3-.5-2-.5-2 0-3.6 1.3-3.6 3s1.6 3 3.6 3 3.6-1.3 3.6-3V4.8c0-.7-.4-1.3-1.2-1.6z"
              />
            </svg>
          </a>
          <a
            className="footer-icon-link"
            href="https://x.com/AIASMusic"
            target="_blank"
            rel="noreferrer"
            aria-label="AIAS on X"
            title="X"
          >
            <svg className="footer-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path
                fill="currentColor"
                d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.727-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77z"
              />
            </svg>
          </a>
        </div>
        <div className="footer-credentials">
          <a
            className="footer-ajax-link"
            href="/credentials/"
            target="_blank"
            rel="noreferrer"
            aria-label="CLASS A · AIAS credentials (password required)"
            title="CLASS A · AIAS"
          >
            <img
              className="footer-ajax-icon"
              src="/brand/golden-ajax-icon.png"
              alt=""
              width={44}
              height={44}
            />
          </a>
        </div>
      </footer>
    </div>
  )
}
